import React, { useEffect, useState } from 'react'

import {
  message, Select, Modal, Input, Form, Switch, Tooltip,
} from 'antd'

import { fetch } from '../../utils/fetch'

const ManageJobModal = ({
  visible, onCancel, onSuccess, editItem,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [action, setAction] = useState('')
  const [jobData, setJobData] = useState([])
  const [masterJob, setMasterJob] = useState([])

  const [form] = Form.useForm()
  const { Option } = Select

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  }

  const getJob = () => {
    setIsLoading(true)
    fetch({
      url: '/management/job',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.data?.success) {
        setJobData(res.data?.data)
      } else {
        message.error(res.data.message)
      }
    })
    setIsLoading(false)
  }

  const getMasterJob = () => {
    setIsLoading(true)
    fetch({
      url: '/master/job',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      if (res.data?.success) {
        console.log(res.data.data)
        setMasterJob(res.data?.data)
      } else {
        message.error(res.data.message)
      }
    })
    setIsLoading(false)
  }

  const create = (values) => {
    console.log(values)
    setIsLoading(true)
    fetch({
      method: 'POST',
      url: '/management/job',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        funcName: values.funcName,
        isActive: values.isActive,
        cron: values.cron,
      },
    }).then((res) => {
      if (res.data?.success) {
        form.resetFields()
        message.success(res.data.message)
        onCancel()
        onSuccess()
      } else {
        message.error(res.data.message)
        onCancel()
      }
    })
    setIsLoading(false)
  }

  const edit = (values) => {
    setIsLoading(true)
    fetch({
      method: 'PUT',
      url: `/management/job/${editItem.cfgJobId}`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        ...jobData,
        funcName: values.funcName,
        isActive: values.isActive,
        cron: values.cron,
      },
    }).then((res) => {
      if (res.data?.success) {
        form.resetFields()
        message.success(res.data.message)
        onCancel()
        onSuccess()
      } else {
        message.error(res.message)
        onCancel()
      }
      setIsLoading(false)
    })
  }

  useEffect(() => {
    getJob()
    getMasterJob()
  }, [])

  useEffect(() => {
    if (!editItem) {
      form.resetFields()
      form.setFieldsValue({ isActive: true })
      setAction('Create')
    } else {
      setAction('Edit')
    }
    form.setFieldsValue(editItem)
  }, [editItem, form])

  return (
    <Modal
      confirmLoading={isLoading}
      title={`${action} Config`}
      maskClosable={false}
      visible={visible}
      cancelText="Cancel"
      onCancel={onCancel}
      okText="Submit"
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            if (action === 'Create') create(values)
            if (action === 'Edit') edit(values)
          })
          .catch((info) => {
            console.log('Validate Failed:', info)
          })
      }}
    >
      <Form
        {...layout}
        form={form}
        name="manage-job-form"
        layout="horizontal"
        initialValues={editItem}
        preserve={false}
      >
        <Form.Item name="funcName" label="Function Name" rules={[{ required: true }]}>
          <Select
            placeholder="-- Please select function --"
            style={{ width: '100%' }}
          >
            {masterJob.length > 0 && masterJob.map((i) => (

              <Option value={i.funcName}><Tooltip title={i.funcDesc} placement="right">{i.funcName}</Tooltip></Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="cron" label="Cron" rules={[{ required: true }]}>
          <Input
            style={{ width: '100%' }}
            placeholder="Please input cron"
          />
        </Form.Item>
        <Form.Item name="isActive" label="Status" valuePropName="checked">
          <Switch defaultChecked />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ManageJobModal
